mutation UpdateConfig($id: ID!, $input: UpdateConfigInput!) {
  updateConfig(id: $id, input: $input) {
    id
  }
}
